const initClasesGrabadasAcciones = () => {
    const contenedor = document.querySelector('.clases-grabadas-single__acciones');

    if (!contenedor) return;

    const favorito = contenedor.querySelector('#favorite');
    const completado = contenedor.querySelector('#marcar-completado');
    const protocol = window.location.protocol;
    const hostname = window.location.hostname;

    favorito.addEventListener('click', async () => {
        const id_clase = favorito.getAttribute('data-id');
        const user_id = favorito.getAttribute('data-user');
        const restBase = protocol + '//' + hostname + '/wp-json/clases-grabadas-favorita-rest/v1';

        const data = {
            action: 'user_acciones_rest',
            user_id,
            id_clase
        };

        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-WP-Nonce': user_acciones_rest.apiNonce,
            },
            credentials: 'same-origin',
            body: JSON.stringify({
                data: data,
            }),
        };

        fetch(restBase + '/update', options)
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    // Mostrar mensaje de éxito
                    alert('Clase marcada como favorita correctamente');
                    favorito.classList.toggle('favorito-activo');
                } else {
                    // Mostrar mensaje de error
                    alert(data.message);
                }
            })
            .catch(error => {
                console.error('Error:', error);
                alert('Ocurrió un error al marcar la clase como favorita');
            }); 
    });

    completado.addEventListener('click', async () => {
        const id_clase = completado.getAttribute('data-id');
        const user_id = completado.getAttribute('data-user');
        const tipo = "clase_grabada";
        const restBase = protocol + '//' + hostname + '/wp-json/clases-grabadas-completada-rest/v1';

        const data = {
            action: 'user_acciones_rest',
            user_id,
            id_clase,
            tipo
        };

        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-WP-Nonce': user_acciones_rest.apiNonce,
            },
            credentials: 'same-origin',
            body: JSON.stringify({
                data: data,
            }),
        };

        fetch(restBase + '/update', options)
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    // Mostrar mensaje de éxito
                    alert('Clase marcada como completada correctamente');
                    completado.textContent = 'Completada';
                } else {
                    // Mostrar mensaje de error
                    alert(data.message);
                }
            })
            .catch(error => {
                console.error('Error:', error);
                alert('Ocurrió un error al marcar la clase como completada');
            });
    });
};

export default initClasesGrabadasAcciones;
